<template>
  <div class="relative">
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title: string;
}>();

defineSlots<{
  default: unknown;
}>();
</script>
